module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "3pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "cont"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/cont.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "2pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "href": "#/07_preface#pref"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "href": "#/08_introduction#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "href": "#/09_chapter01#c01"
    }
  }, [_vm._v("Regency Parenting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/09_chapter01#c01-01"
    }
  }, [_vm._v("Passage Rights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/09_chapter01#c01-07"
    }
  }, [_vm._v("What' a Kid Ready to Learn About Wicca?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter02#c02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Infancy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter02#c02-01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Babies Need Most")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter02#c02-06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ivy's Song")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter03#c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Childhood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter03#c03-01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Young Children's Anger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter03#c03-02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mythical Children")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter03#c03-06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patience, Please")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter03#c03-07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magical Security")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter03#c03-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cakes and Ale and Children")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter03#c03-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making a Robe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter03#c03-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wheel of the Year")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter03#c03-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Spells Work")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/12_chapter04#c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Later Childhood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter04#c04-02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Keeping Secrets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter04#c04-04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Animal Associations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter04#c04-06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plant Associations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter04#c04-07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teaching corrspondences Through Word Games")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter04#c04-08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Questions Religions Address")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter04#c04-09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skyclad Children")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter04#c04-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acorns Don't Provide Shade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter05#c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adolescence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter05#c05-01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mirror in the Meadow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter05#c05-02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wiccan Rede")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter05#c05-07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guilt Trips")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter05#c05-08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Commitments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter05#c05-09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advantages of Guided Meditations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/14_chapter06#c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Young Adulthood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter06#c06-01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The War Against Children")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter06#c06-02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Retreat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter06#c06-06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your First Book of Shadows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter06#c06-07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religion and Politics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter06#c06-09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter07#c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sun Day School")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter07#c07-01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before You Print the Flyers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter07#c07-02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saying No")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter07#c07-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reinforcing Your Lessons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter07#c07-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Later Childhood: Syllabus for six sessions:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter07#c07-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sample Lesson Plan: Session Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/16_glossary#gloss",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/17_bibliography#biblio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography and Recommended Readings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/18_index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/19_abouttheauthor#author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7144d49e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_contents.vue
// module id = 72
// module chunks = 0